import ModalStack from '@/components/Custom/ModalStack';

export default function PrivateEventEventIdScoreDeleteLayoutRoute() {
  return <ModalStack />;
}
